<template>
    <div class="topbar">
        <span class="debug-icon" v-if="debug">
            <i class="i-andy-menu-help i-andy-m" @click="debugFryers = !debugFryers"></i>
        </span>
        <span class="title">{{ $t('production.plk.fryers.status') }}</span>

        <div class="state" v-for="fryer in fryers" :key="fryer.id" :class="{ 'in-use': fryer.status == 2, 'available': fryer.status == 1 , 'unavailable': fryer.status == -1}" @click="toggleFryer(fryer.id)">
            <template v-if="fryer.status == 2">
                <i class="i-andy-hourglass-warning i-andy-m"></i>
                <span class="text">{{ $t('production.plk.fryers.state.in-use') }}</span>
            </template>
            <template v-else-if="fryer.status == -1">
                <i class="i-andy-menu-task i-andy-m"></i>
                <span class="text">{{ $t('production.plk.fryers.state.unavailable') }}</span>
            </template>
            <template v-else-if="fryer.status == 1">
                <i class="i-andy-done i-andy-m"></i>
                <span class="text">{{ $t('production.plk.fryers.state.available') }}</span>
            </template>
        </div>
        <div class="debug" v-if="debugFryers">
            <DebugFryers :fryers="fryers" />
        </div>
    </div>
</template>

<script>
import DebugFryers from './debugFryers.vue'

export default {
    name: 'FryerStates',
    components: {
        DebugFryers
    },
    props: {
        fryers: {
            type: Array,
            required: true
        },
        debug: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            debugFryers: false
        }
    },
    methods: {
        toggleFryer(id) {
                //To enable or disable the fryer
            const fryers = JSON.parse(JSON.stringify(this.fryers))
            fryers.forEach(fryer => {
                if(fryer.id == id && fryer.status != 2){
                    fryer.status = fryer.status == 1 ? -1 : 1
                }
            })

            this.$store.commit('production/setFryers', fryers)
            this.$store.dispatch('production/toggleFryer', fryers)
        }
    },
    watch: {
        fryers: {
            handler() {
                // Forzar actualización cuando cambian las freidoras
                this.$forceUpdate()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.topbar {
    grid-area: topbar;
    height: 100%;
    @include display-flex();
    @include align-items(center);
    @include flex-direction(row);
    padding: 8px 24px;
    gap: 16px;
    position: relative;

    .debug-icon {
        cursor: pointer;
        i[class^="i-andy-"] {
            color: $color-success-500;
        }
    }

    .debug {
        position: absolute;
        width: 500px;
        height: 100vh;
        background-color: $color-white;
        z-index: 1000;
        top: 0;
        right: 0;
        border-radius: 4px;
        padding: 16px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    }

    .title {
        color: $color-black;
        font-family: $text-bold;
        @include font-size(18px);
        line-height: 120%;
        word-break: break-word;
    }

    .state {
        width: 130px;
        padding: 17.5px 10px;
        border-radius: 4px;
        cursor: pointer;

        @include display-flex();
        @include justify-content(center);
        @include align-items(center);
        @include flex-direction(column);

        .text {
            font-family: $text;
            @include font-size(12px);
            text-transform: uppercase;
        }

        &.in-use {
            background-color: $color-warning-100;

            .text,
            i {
                color: $color-warning-800;
            }
        }

        &.available {
            background-color: $color-success-100;

            .text,
            i {
                color: $color-success-800;
            }
        }

        &.unavailable {
            background-color: $color-error-500;

            .text,
            i {
                color: $color-white;
            }
        }
    }

}
</style>